import * as Sentry from '@sentry/react';

/**
 * the following Sentry configurations are copied from Talos
 */
export const SENTRY_INIT_CONFIG: Sentry.BrowserOptions = {
    // This is the DSN for the `rofl-ui` project.
    dsn: 'https://1635e3f4d23054ac457bda3b0d8b5246@o1899.ingest.sentry.io/4505745053974528',
    integrations: [
        // see Sentry doc for integration options
        // https://docs.sentry.io/platforms/javascript/?platform=browsernpm
        new Sentry.BrowserTracing(),
        Sentry.replayIntegration(),
    ],
    ignoreErrors: ['AbortError'],
    enabled: process.env.ENVIRONMENT === 'staging' || process.env.ENVIRONMENT === 'production',
    environment: process.env.ENVIRONMENT,
    // The documentation says the default is 30, but I see 100 when this is not set.
    maxBreadcrumbs: 10,
    // How deep into nested objects it will traverse.
    normalizeDepth: 5,
};
